module.exports = __webpack_public_path__ + "img/icone-data.61732d62.svg";